import React, { useState, useEffect } from "react";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { useUser } from "../../../pages/authentification/UserContext";
import { API_ENDPOINTS } from "../../../../ApiService";
import apiService from "../../../../ApiService";

import {
  Box,
  useTheme,
  useMediaQuery,
  Typography,
  Button,
} from "@mui/material";
import styled from "styled-components";
import Grid from "@mui/material/Unstable_Grid2";
import { tokens } from "../../../../theme";
import { MainContainer } from "../../../pages/styles/sharedStyles";
import Title from "../../title/Title";
import TimeSeriesWeightChart from "./TimeSeriesWeightChart";

const Section = styled.section`
  width: 100%;
  height: 100%;
  padding: 4rem 0rem;
`;

const WeightGraph = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { clientID } = useParams();
  const [clientData, setClientData] = useState(null);
  const [poids, setPoids] = useState([]);

  const { user } = useUser();
  const { id } = user;

  const hasData = poids && poids.length > 0;

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await apiService.get(
          `${API_ENDPOINTS.CLIENTDASHBOARD}/${clientID}`
        );
        setClientData(response.data);
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    if (clientID) {
      fetchClientData();
    }
  }, [clientID]);

  useEffect(() => {
    const fetchPoids = async () => {
      try {
        if (clientData && id) {
          const response = await apiService.get(
            API_ENDPOINTS.CLIENT_POIDS(clientID)
          );
          const poidsData = response.data;
          // Sort by date descending
          poidsData.sort(
            (a, b) => new Date(b.datepoids) - new Date(a.datepoids)
          );
          console.log("Dashboard poids", poidsData);
          setPoids(poidsData);
        }
      } catch (error) {
        console.error("Error fetching poids:", error);
      }
    };

    fetchPoids();
  }, [clientData]);

  // Create raw data for the time series chart.
  // Each object must have a 'date' and a 'value'
  const rawWeightData = poids.map((item) => ({
    date: item.datepoids, // or new Date(item.datepoids).toISOString() if needed
    value: item.poids,
  }));

  if (!clientData) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <Section>
      {!hasData ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={4}
          bgcolor="lightgrey"
          borderRadius="8px"
          boxShadow={2}
        >
          <Typography variant="h6" color="textPrimary">
            Aucune donnée disponible pour le moment.
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={1}>
            Quand tu commenceras à ajouter des valeurs, elles apparaitront ici.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => navigate(`/weightupdate/${clientID}`)}
          >
            Ajouter un poids
          </Button>
        </Box>
      ) : (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid xs={12}>
            <TimeSeriesWeightChart rawData={rawWeightData} />
          </Grid>
        </Grid>
      )}
    </Section>
  );
};

export default WeightGraph;
